import { FormGroup, Validators } from "@angular/forms"
import { LayerType, sharedForms } from "../layer.model"
import { BaseProperties, BuildingProperties, FormType, Properties } from "../properties.model"
import { Subject } from "rxjs"

export const baseForm: Properties = {
  propertyType: LayerType.Base,
  label: 'Base Layer',
  forms:
    sharedForms.concat([
    {
      id: BaseProperties.NilPixelColor,
      label: 'Empty Pixel Color',
      type: FormType.Color,
      placeholder: "#Hex Color",
      hint: "Change the color of empty pixels, this is anywhere that the render box did not find any elements",
      defaultValue: '#FFFFFF',
      validators: [Validators.required, Validators.min(1)],
    },
    {
      id: BaseProperties.NilPixelOpacity,
      label: 'Empty Pixel Opacity',
      type: FormType.SliderNumber,
      defaultValue: 1,
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
  ]),
  changeHandler: (fg: FormGroup, formChanged: Subject<void>) => {},
  onInit: (data) => {}
}
